import { Component, OnInit } from '@angular/core';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService } from '../utilities/services/api.service';
import { UntypedFormGroup } from '@angular/forms';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { TextBoxModel } from '@app/components/controls/utilities/models/text-box-model';
import { TextAreaModel } from '@app/components/controls/utilities/models/text-area-model';
import { AutoCompleteModel } from '@app/components/controls/utilities/models/auto-complete-model';
import { BaseService } from '@app/system/services/base.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';

@Component({
	selector: 'app-workgroup-forms',
	templateUrl: './workgroup-forms.component.html',
	styleUrls: ['./workgroup-forms.component.scss']
})
export class WorkgroupFormsComponent implements OnInit {

	action: 'createWorkgroup' | 'inviteUsers' | 'sendRequest' | 'editWorkgroup' | 'workgroupDetail';
	formFields: any = [];
	config = { fxFlex: 100 };
	title;
	info;
	formObject;
	submitDisable = true;
	popupRef;
	currentUser;
	workGroupData;
	formPopup = true;
	clearTimeout;
	deviceDetails;
	tabIndex = 0;
	actionTab;
	actionFrom;

	constructor(
		private apiService: ApiService,
		private gfService: GlobalFunctionService,
		private appInit: AppInitializerService,
		public detectDevice: DetectDeviceService,
		public locale: LocaleService,
		private baseService: BaseService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.deviceDetails = this.detectDevice.fingerPrint;
		this.baseService.formView = true;
		if (this.action === 'createWorkgroup' || this.action === 'editWorkgroup') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('new_workgroup');
			// this.info = this.locale.translate('new_workgroup_info');
			const groupName: TextBoxModel = {
				fieldColumn: 'groupName',
				fieldCaption: this.locale.translate('title'),
				additionalMetaData: {
					maxChar: 100,
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					patternMatch: ''
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				value: null,
				fieldPlaceholder: this.locale.translate('title'),
				fieldOrder: 1
			};

			const groupDescription: TextAreaModel = {
				fieldColumn: 'groupDescription',
				fieldCaption: this.locale.translate('desc'),
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('desc'),
				fieldOrder: 2
			};

			if (this.action === 'editWorkgroup' && this.workGroupData) {
				this.title = this.locale.translate('edit_workgroup');
				groupName.value = this.workGroupData.groupName;
				groupDescription.value = this.workGroupData.groupDescription;
			}
			this.formFields = [groupName, groupDescription];
			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} else if (this.action === 'inviteUsers') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('invite_users');
			this.info = this.locale.translate('invite_users_info');
			const toUserIDArray: AutoCompleteModel = {
				fieldColumn: 'toUserIDArray',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					max: 1
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('type_names'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('type_names')
			};

			this.formFields = [toUserIDArray];
			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} else if (this.action === 'sendRequest') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('send_request');
			this.info = this.locale.translate('send_request_info');
			const toUserIDArray: AutoCompleteModel = {
				fieldColumn: 'toUserIDArray',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					max: 1
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('type_names'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('type_names')
			};

			this.formFields = [toUserIDArray];
			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} else if (this.action === 'workgroupDetail') {
			this.title = this.workGroupData.groupName;
			if (this.actionTab) {
				if (this.actionTab === 'members') {
					this.tabChange(1);
				} else if (this.actionTab === 'assignments') {
					this.tabChange(0);
				}
			}
		}
	}

	getCount(data: any) {
		if (data && this.popupRef) {
			this.popupRef.componentInstance.dialogCloseData = data;
		}
	}

	tabChange(index) {
		this.tabIndex = index;
	}

	submit() {
		if (navigator.onLine) {
			if (this.action === 'createWorkgroup' || this.action === 'editWorkgroup') {
				this.createWorkgroup();
			} else if (this.action === 'inviteUsers') {
				this.submitInvite();
			} else if (this.action === 'sendRequest') {
				this.submitRequest();
			}
		}
	}

	createWorkgroup() {
		if (this.formObject && this.formObject.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('workgroupAlert');
			if (this.formObject.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				if (this.action === 'createWorkgroup') {
					this.apiService
						.saveWorkGroup(formData, headers)
						.subscribe(
							(response) => {
								this.baseService.logUserActivity('wgnew', 'engagement', ['']);
								this.popupRef.close(this.gfService.JSONMerge(formData, response));
								this.gfService.openSnackBar('SUCCESS', {
									message: this.locale.translate('workgroup_created'),
									icon: 'check_circle_outline',
									position: 'before'
								});
							},
							(error) => {
								this.gfService.errorHandler(error, {
									alert: {
										id: 'workgroupAlert'
									},
									form: this.formObject.form
								});
							}
						)
						.add(() => {
							this.submitDisable = false;
							this.popupRef.componentInstance.popupLoader = false;
						});
				} else {
					const apiData = this.gfService.JSONMerge(formData, {
						name: formData.groupName,
						description: formData.groupDescription
					});
					this.apiService
						.updateWorkGroup(apiData, this.workGroupData.groupID, headers)
						.subscribe(
							(response) => {
								this.popupRef.close(this.gfService.JSONMerge(apiData, response));
								this.gfService.openSnackBar('SUCCESS', {
									message: this.locale.translate('workgroup_updated'),
									icon: 'check_circle_outline',
									position: 'before'
								});
							},
							(error) => {
								this.gfService.errorHandler(error, {
									alert: {
										id: 'workgroupAlert'
									},
									form: this.formObject.form
								});
							}
						)
						.add(() => {
							this.submitDisable = false;
							this.popupRef.componentInstance.popupLoader = false;
						});
				}
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	submitInvite() {
		if (this.formObject && this.formObject.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('workgroupAlert');
			if (this.formObject.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				formData.Notes = 'sending invites';
				formData.WGID = this.workGroupData.groupID;
				const UserIds = [];
				for (const data of formData.toUserIDArray) {
					if (data.isAdd && !data.isDelete) {
						UserIds.push(data.key.userID);
					}
				}

				const invitedUsers = [];
				for (const data of formData.toUserIDArray) {
					if (data.isAdd && !data.isDelete) {
						invitedUsers.push(data);
					}
				}
				formData.invitedUsers = invitedUsers;
				const apiValue = this.gfService.JSONMerge(formData, { toUserIDARRAY: UserIds });
				apiValue.notificationType = 1;
				if (this.deviceDetails.browserName === 'Safari') {
					apiValue.notificationType = 2;
				}
				this.apiService
					.saveInvites(apiValue, headers)
					.subscribe(
						(response) => {
							// this.baseService.logUserActivity('AddMemberToWorkgroup', ['']);
							this.popupRef.close(this.gfService.JSONMerge(apiValue, response));
							this.gfService.openSnackBar('SUCCESS', {
								message: this.locale.translate('invite_sent'),
								icon: 'check_circle_outline',
								position: 'before'
							});
						},
						(error) => {
							if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'DUPLICATE') {
								error.error = this.locale.translate('you_have_already_sent_invites_desc');
							} else if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'RECURSIVE_MEMBER') {
								error.error = this.locale.translate('this_invites_has_aborted');
							}
							this.gfService.errorHandler(error, {
								alert: {
									id: 'workgroupAlert'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	submitRequest() {
		if (this.formObject && this.formObject.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('workgroupAlert');
			if (this.formObject.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				formData.userList = [];
				const userIds = [];
				for (const data of formData.toUserIDArray) {
					if (data.isAdd && !data.isDelete) {
						userIds.push(data.key.userID);
						formData.userList.push(data.key);
					}
				}
				let apiValue = {
					toUserID: userIds[0],
					Notes: 'Sending request',
					notificationType: 2

				};
				if (this.deviceDetails.browserName === 'Safari') {
					apiValue.notificationType = 2;
				}
				// const apiValue = this.gfService.JSONMerge(formData, { toUserID: userIds[0] });
				this.apiService
					.saveRequest(apiValue, headers)
					.subscribe(
						(response) => {
							this.baseService.logUserActivity('wgrequests', 'engagement', ['']);
							apiValue = this.gfService.JSONMerge(formData, { toUserID: userIds[0] });
							this.popupRef.close(this.gfService.JSONMerge(apiValue, response));
							this.gfService.openSnackBar('SUCCESS', {
								message: this.locale.translate('request_sent'),
								icon: 'check_circle_outline',
								position: 'before'
							});
						},
						(error) => {
							if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'DUPLICATE') {
								error.error = this.locale.translate('you_have_already_sent_request');
							} else if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'ALREADY_MEMBER') {
								error.error = this.locale.translate('user_being_already_member');
							} else if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'RECURSIVE_MEMBER') {
								error.error = this.locale.translate('this_request_has_aborted');
							}
							this.gfService.errorHandler(error, {
								alert: {
									id: 'workgroupAlert'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	formObjectReader(record: any) {
		this.formObject = record;
		if (this.action === 'inviteUsers' || this.action === 'sendRequest') {
			let subscribe;
			const form: UntypedFormGroup = this.formObject.form;
			const userField = this.formFields.find((items) => items.fieldColumn === 'toUserIDArray');

			form.controls.toUserIDArray.valueChanges.subscribe((controlResp) => {
				if (subscribe && !subscribe['closed']) {
					subscribe.unsubscribe();
				}
				if (this.clearTimeout) {
					clearTimeout(this.clearTimeout);
				}
				this.clearTimeout = setTimeout(() => {
					if (controlResp && typeof controlResp === 'string') {
						const apiData: any = {
							searchString: controlResp
						};
						if (this.action === 'inviteUsers') {
							apiData.groupID = this.workGroupData.groupID
						}
						const header: any = {};
						let selectedValue = [];
						if (userField.selectedValue.length) {
							userField.selectedValue.map(items => {
								if (items.isAdd && !items.isDelete) {
									selectedValue.push(items.key.userID);
								}
							});
						}
						subscribe = this.apiService.getUsers(apiData, header).subscribe(
							(response) => {
								if (response && response.hasOwnProperty('records')) {
									if (selectedValue.length) {
										response.records = response.records.filter(items => {
											if (!selectedValue.includes(items.userID)) {
												return items;
											}
										});
									}
									userField.options = response.records.map((data) => {
										return {
											key: data,
											value: `${data.firstName}${data.lastName
												? ' ' + data.lastName
												: ''}`,
											prefix: {
												type: 'image',
												value: data.profilePicURL
											},
											shortInfo: this.baseService.getUserShortInfo(data)
										};
									});
								} else {
									userField.options = [];
								}
							},
							(error) => {
								this.gfService.errorHandler(error, {
									snackBar: {
										position: 'before'
									}
								});
								userField.options = [];
							}
						);
					} else {
						userField.options = [];
					}
				}, this.appInit.configuration.searchDelay);
			});
		}
	}
}
